import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/icons/search.svg'
import _imports_1 from '@/assets/icons/pagefirstenabled.svg'
import _imports_2 from '@/assets/icons/pagefirstdisabled.svg'
import _imports_3 from '@/assets/icons/pagelastenabled.svg'
import _imports_4 from '@/assets/icons/pagelastdisabled.svg'


const _hoisted_1 = { class: "keyscontroltext" }
const _hoisted_2 = { class: "utils" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"25px"},
  alt: "searchimg",
  title: "searchimg"
}, null, -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = { class: "expiration-cell" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 0,
  class: "pagingdiv",
  "data-cy": "productkeys-pagination"
}
const _hoisted_9 = { class: "pagelabel" }
const _hoisted_10 = {
  key: 0,
  src: _imports_1,
  style: {"width":"20px"},
  alt: "firstpageimg",
  title: "firstpageimg"
}
const _hoisted_11 = {
  key: 1,
  src: _imports_2,
  style: {"width":"20px"},
  alt: "firstpagedisabledimg",
  title: "firstpagedisabledimg"
}
const _hoisted_12 = {
  key: 0,
  src: _imports_3,
  style: {"width":"20px"},
  alt: "lastpageimg",
  title: "lastpageimg"
}
const _hoisted_13 = {
  key: 1,
  src: _imports_4,
  style: {"width":"20px"},
  alt: "lastpagedisabledimg",
  title: "lastpagedisabledimg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.showOptions)
          ? (_openBlock(), _createBlock(_component_el_input, {
              key: 0,
              id: "productIdSearch",
              modelValue: _ctx.productKeySearchVal,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.productKeySearchVal) = $event)),
              placeholder: "Search",
              type: "search",
              class: "rightmargin inpstyle",
              "data-cy": "productkeys-input-search"
            }, {
              suffix: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }, 8, ["modelValue"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      id: "productKeystable",
      data: _ctx.productKeyList,
      style: {"width":"100%"},
      "max-height": "600px",
      "scrollbar-always-on": "",
      "header-cell-style": _ctx.headerstyle,
      onSortChange: _ctx.handleSorting,
      "row-style": _ctx.rowdatastyle,
      "empty-text": _ctx.nodatatxt,
      "data-cy": "productkeys-table"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "Product Key",
          prop: "productKey"
        }, {
          default: _withCtx((props) => [
            _createElementVNode("div", null, _toDisplayString(props.row.productKey), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Product",
          prop: "productName",
          sortable: "custom"
        }, {
          default: _withCtx((props) => [
            _createElementVNode("div", null, _toDisplayString(props.row.productName), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Type",
          prop: "typeName",
          sortable: "custom"
        }, {
          default: _withCtx((props) => [
            _createElementVNode("div", null, _toDisplayString(props.row.typeName), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Status",
          prop: "status",
          sortable: "custom"
        }, {
          default: _withCtx((props) => [
            _createElementVNode("div", null, _toDisplayString(props.row.status), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Expiration Date",
          align: "center",
          prop: "endDate",
          sortable: "custom"
        }, {
          default: _withCtx((props) => [
            (_ctx.checkExpirationDate(props.row.endDate))
              ? (_openBlock(), _createBlock(_component_el_tooltip, {
                  key: 0,
                  placement: "top"
                }, {
                  content: _withCtx(() => [
                    (_ctx.expiringIn30Days)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                          _createTextVNode(" The license has expired or is about to expire shortly. "),
                          _hoisted_5,
                          _createTextVNode("Please unassign the expired license and assign the new license. ")
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, _toDisplayString(props.row.endDate), 1)
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true),
            (!_ctx.checkExpirationDate(props.row.endDate))
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(props.row.endDate), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "User",
          prop: "lastname",
          sortable: "custom"
        }, {
          default: _withCtx((props) => [
            _createVNode(_component_el_link, {
              type: "primary",
              underline: 'never',
              onClick: ($event: any) => (_ctx.viewUserDetails(props.row)),
              style: {"cursor":"pointer"},
              class: "linkText",
              "data-cy": "productkeys-link-user"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(props.row.userName), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Company",
          prop: "companyName",
          sortable: "custom"
        }, {
          default: _withCtx((props) => [
            _createVNode(_component_el_link, {
              type: "primary",
              underline: 'never',
              onClick: ($event: any) => (_ctx.viewCompanyDetails(props.row)),
              style: {"cursor":"pointer"},
              class: "linkText",
              "data-cy": "productkeys-link-company"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(props.row.companyName), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "header-cell-style", "onSortChange", "row-style", "empty-text"])), [
      [_directive_loading, _ctx.loading]
    ]),
    (_ctx.totalPages > 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("label", _hoisted_9, [
            _createElementVNode("strong", null, "Page " + _toDisplayString(_ctx.currentPage) + " / " + _toDisplayString(_ctx.totalPages), 1)
          ]),
          _createVNode(_component_el_button, {
            plain: "",
            class: "paginationbtn",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onPageChange(1))),
            id: "firstpage",
            disabled: _ctx.currentPage === 1
          }, {
            default: _withCtx(() => [
              (_ctx.currentPage !== 1)
                ? (_openBlock(), _createElementBlock("img", _hoisted_10))
                : _createCommentVNode("", true),
              (_ctx.currentPage === 1)
                ? (_openBlock(), _createElementBlock("img", _hoisted_11))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_el_pagination, {
            layout: "prev, next",
            total: _ctx.totalRowsCount,
            "page-size": 5,
            "current-page": _ctx.currentPage,
            "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.currentPage) = $event)),
            onCurrentChange: _ctx.onPageChange
          }, null, 8, ["total", "current-page", "onCurrentChange"]),
          _createVNode(_component_el_button, {
            plain: "",
            class: "paginationbtn",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onPageChange(_ctx.totalPages))),
            id: "lastpage",
            disabled: _ctx.currentPage === _ctx.totalPages
          }, {
            default: _withCtx(() => [
              (_ctx.currentPage !== _ctx.totalPages)
                ? (_openBlock(), _createElementBlock("img", _hoisted_12))
                : _createCommentVNode("", true),
              (_ctx.currentPage === _ctx.totalPages)
                ? (_openBlock(), _createElementBlock("img", _hoisted_13))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["disabled"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}